module.exports = __webpack_public_path__ + "static/media/09_insideyourblood.3dc16313.jpg";